// RowActionsMenu.jsx
import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PropTypes from "prop-types";

const RowBranchActionsMenu = ({
  row,
  onDelete,
  onEdit,
  onCreateBranchIntake,
  onViewBranchIntakes,
  hasPermission,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const isInactive = row.is_branch_active == 0;
  return (
    <>
      <IconButton onClick={handleOpen}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {!hasPermission("edit") && (
          <MenuItem
            onClick={() => {
              onEdit(row);
              handleClose();
            }}
          >
            Edit Branch
          </MenuItem>
        )}
        {hasPermission("delete") && (
          <MenuItem
            onClick={() => {
              onDelete(row.branch_id);
              handleClose();
            }}
          >
            Delete Branch
          </MenuItem>
        )}
        <MenuItem
          disabled={isInactive}
          onClick={() => {
            onCreateBranchIntake(row.branch_id, row.program_id, row.college_id, row.branch_name);
            handleClose();
          }}
        >
          Create Branch Intake
        </MenuItem>
        <MenuItem
          disabled={isInactive}
          onClick={() => {
            onViewBranchIntakes(row.branch_id, row.program_id, row.college_id, row.branch_name);
            handleClose();
          }}
        >
          View Branch intake
        </MenuItem>
      </Menu>
    </>
  );
};
RowBranchActionsMenu.propTypes = {
  row: PropTypes.shape({
    college_id: PropTypes.number.isRequired,
    program_id: PropTypes.number.isRequired,
    branch_id: PropTypes.number.isRequired,
    branch_desc: PropTypes.string.isRequired,
    branch_name: PropTypes.string.isRequired,
    program_name: PropTypes.string.isRequired,
    is_branch_active: PropTypes.number.isRequired,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onCreateBranchIntake: PropTypes.func.isRequired,
  onViewBranchIntakes: PropTypes.func.isRequired,
  hasPermission: PropTypes.func.isRequired,
};
export default RowBranchActionsMenu;
